import React from 'react';
import { render } from 'react-dom';
import axios from 'axios';

import withDataFetch from '../../api-components/hoc/withDataFetch';
import DistrictMap from './DistrictMap';
import select from '../../utils/select';
import { SELECTOR } from './constants';

function buildFetcher({ slug, number }) {
  const domain = 'https://districts.texastribune.org';
  const url = `${domain}/${slug}/current/${number}.json`;

  return async () => {
    const { data } = await axios.get(url);
    return [data];
  };
}

export default function buildDistrictMap({ slug, number }) {
  const ComponentWithFetch = withDataFetch(DistrictMap, {
    fetcher: buildFetcher({ slug, number }),
    showLoader: true,
  });

  render(<ComponentWithFetch />, select(`#${SELECTOR}`));
}
